import React, { useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { DrawerHeader } from "@/components/ui/drawer";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { Step } from "./constants";
import Card from "@/components/custom/card";
import { useTranslation } from "react-i18next";
import Loading from "@/components/custom/loading";
import { useGetBudgetSubCategories } from "@/services/queries/budgets";
import { ExpenseFormValues } from "./";

const BudgetSubcategoryStep = ({
  form,
  setStep,
}: {
  form: UseFormReturn<ExpenseFormValues>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { t } = useTranslation();
  const { data: subcategoriesData, isPending } = useGetBudgetSubCategories({
    id: form.watch("budgetCategoryId") || "",
  });

  const subcategories = useMemo(() => {
    return subcategoriesData?.value || [];
  }, [subcategoriesData]);

  return (
    <div>
      <DrawerHeader
        title={t("title.budget_subcategory")}
        leftButton={
          <button
            type="button"
            onClick={() => setStep(Step.CATEGORIES)}
            className="w-6"
          >
            <CaretLeft color="#E3EDFC" size={18} />
          </button>
        }
        rightButton={<span className="w-6" />}
      />

      <p className="mx-auto max-w-[210px] text-center text-sm font-medium leading-[18px] text-[#98B2D3]">
        {t("description.budget_subcategory")}
      </p>

      {isPending ? (
        <Loading className="mt-10" />
      ) : (
        <div className="mt-5 space-y-[15px]">
          {subcategories.length > 0 ? (
            subcategories.map((subcategory) => (
              <Card
                data-testid={`expense-form-subcategory-item-${subcategory.id}`}
                onClick={() => {
                  form.setValue("budgetSubcategoryId", subcategory.id);
                  setStep(Step.INITAL);
                }}
                className="px-[15px] py-[14px]"
                key={subcategory.id}
              >
                <div className="flex flex-col items-start justify-between gap-3">
                  <span className="text-[15px] font-medium leading-[18px] text-white">
                    {subcategory.name}
                  </span>
                </div>
                <CaretRight color="#E3EDFC" size={18} />
              </Card>
            ))
          ) : (
            <div className="mx-auto my-2 mt-5 max-w-[200px] text-center text-[15px] text-white">
              {t("description.not_found_budget_subcategory")}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BudgetSubcategoryStep;
